import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" {...props}>
    <path
      fill="none"
      stroke="#919499"
      d="M4.084 12.566c-.129.335-.384.702-.764 1.101-.15.157.134.387.44.322.534-.114 1.307-.455 2.32-1.023a1 1 0 0 1 .49-.128h1.8c1.359 0 6.63-1.165 6.63-5.862C15 2.595 11.382 1 8.37 1 5.311 1 1 2.406 1 6.976c.058 1.927.941 3.381 2.65 4.364a1 1 0 0 1 .434 1.226z"
    />
  </svg>
);
const Memo = memo(SvgMessage);
export default Memo;
